import {Avatar, Popconfirm} from 'antd'
import DrawMenu from 'components/drawer/DrawMenu'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useContext} from 'react'
import {IoEllipsisHorizontal} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import FeedContext from '../FeedContext'
import _ from "lodash";
import {PinnedIcon} from "../../../assets/svgs/PinnedIcon";
import {PiNotePencil} from "react-icons/pi";
import {RiSignalTowerFill} from "react-icons/ri";
import {BsBookmarkHeart, BsBookmarks, BsBookmarkX, BsFillPinAngleFill, BsPersonFill, BsPinAngle} from "react-icons/bs";
import {BiSolidChurch, BiTrash} from "react-icons/bi";
import TooltipApp from "components/TooltipApp";
import {useHistory} from "../../../modules/navigation/useRouter";
import {getType} from "../../../apis/model/base";
import classNames from "classnames";
import {formatRelativeTime, formatSimplifyDate} from "../../../helpers/dateUtils";
import {FollowButton} from "../FollowButton";
import {renderIf} from "../../../views/Shared";

const AskContentMeta = ({...props}) => {

    const t = useTranslate()
    const history = useHistory()
    const permissions = useContext(PermissionContext)

    const {item, created, actions, creatorName, embed_data, handleClick} = useContext(FeedContext)

    const handleMenuClick = (e) => {
        handleClick(e.key)
    }
    const availbleActions = [
        [RiSignalTowerFill, 'set_channel', 'set_channel', 'text-green-500'],
        [BsBookmarkHeart, 'bookmark', 'bookmark', 'text-color-400'],
        [BsBookmarks, 'rebookmark', 'rebookmark', 'text-color-400'],
        [BsBookmarkX, 'unbookmark', 'unbookmark', 'text-color-400'],
        item?.pin_status ? [BsFillPinAngleFill, 'unpin', 'unpin', 'text-green-500'] : [BsPinAngle, 'pin', 'pin', 'text-green-500'],
        item?.edit ? [PiNotePencil, 'edit', 'edit', 'text-blue-500'] : [],
        [BiTrash, 'delete', 'delete', 'text-primary-300'],
    ].filter(([, key]) => {
        return permissions[key]
    })


    return (
        <div className="w-full flex flex-col mt-1">
            <div className="flex flex-1 items-center gap-2 mr-10">
                <Avatar
                    size={40}
                    src={_.get(item, 'owner.avatar')}
                    icon={
                        getType(item?.owner) === 'organization' ?
                            <BiSolidChurch size={20} className="text-color-500"/> :
                            <BsPersonFill size={20} className="text-color-500"/>
                    }
                    className={classNames(
                        "flex flex-center flex-shrink-0 background-200",
                        getType(item?.owner) === 'organization' && 'rounded-md'
                    )}
                />
                <div className="flex flex-col flex-1 min-w-0">
                    <Link
                        to={getLinkToDetail(item?.owner)}
                        className="font-bold text-sm text-gray-800 tracking-wide truncate no-underline">
                        {getTitle(item?.owner)}
                    </Link>
                    <div className="flex items-center min-w-0 leading-snug">
                        <span className="mr-1 flex-shrink-0 text-xs text-color-300 tracking-wider">
                            {/*{t('posted').toLowerCase()}*/}
                            <label>
                                {formatRelativeTime(created)}
                            </label>
                            {/*{t('on channel')}*/}
                        </span>
                        <span className="ml-1 mr-1 flex-shrink-0 text-color-300">
                            {`\u2022 `}
                        </span>
                        <Link
                            to={getLinkToDetail(item.container)}
                            className="min-w-0 block truncate font-semibold text-xs text-color-200 hover:text-color-100 no-underline">
                            {getTitle(item.container)}
                        </Link>
                        <div className="flex-shrink-0 ml-1 leading-4">
                            <FollowButton
                                renderLabel={(_item) => renderIf(
                                    !_item?.follow_status,
                                    <label className="text-xs not-italic cursor-pointer">
                                        {`\u2022 ${t('follow')}`}
                                    </label>
                                )}
                                item={item?.container}
                            />
                        </div>
                    </div>
                </div>
                {availbleActions.length > 0 && (
                    <DrawMenu
                        menu={{
                            items: availbleActions?.map(([Icon, key, label, color]) => ({
                                key: key || label,
                                icon: <Icon size={14} className={color}/>,
                                label: t(label || key || ''),
                            })),
                            onClick: handleMenuClick,
                        }}
                        component={
                            <Avatar
                                size={28}
                                icon={<IoEllipsisHorizontal size={18} className="text-color-200 hover:text-color-100"/>}
                                className="flex flex-center background hover:background-200 cursor-pointer absolute right-5 top-0 contextIcon"
                            />
                        }
                    />
                )}
            </div>

            {!!item?.pin_status && (actions?.pin && !!item?.edit ? (
                <Popconfirm
                    placement="bottomLeft"
                    title={<span className="font-medium italic">{t('unpin this')}</span>}
                    onConfirm={() => handleClick('unpin')}
                    okText={t('yes')}
                    cancelText={t('no')}
                    okButtonProps={{
                        type: 'primary',
                        className: 'button-rounded-md no-border text-xs px-3',
                    }}
                    cancelButtonProps={{className: 'button-rounded-md no-border text-xs text-color-400 px-3'}}>
                    <TooltipApp title={t('unpin the post')}>
                        <PinnedIcon
                            size={18}
                            className="cursor-pointer custom-pin-icon ml-1 md:ml-3"
                        />
                    </TooltipApp>
                </Popconfirm>
            ) : (
                <span/>
            ))}
        </div>
    )
}

export default AskContentMeta
